export const handleDropdowns = () => {
  const handleDefaultDropdowns = () => {
    const dropdowns = document.querySelectorAll('.dropdown');

    if (!dropdowns.length) return

    dropdowns.forEach(dropdown => {
      const menuButton = dropdown.querySelector('.menu-button');
      const dropdownMenu = dropdown.querySelector('.dropdown-menu');

      menuButton.addEventListener('click', function() {
        const expanded = menuButton.getAttribute('aria-expanded') === 'true' || false;
        menuButton.setAttribute('aria-expanded', !expanded);
        dropdownMenu.classList.toggle('hidden');
      });

      // Close dropdown when clicking outside of it
      document.addEventListener('click', function(event) {
        if (!menuButton.contains(event.target) && !dropdownMenu.contains(event.target)) {
          menuButton.setAttribute('aria-expanded', 'false');
          dropdownMenu.classList.add('hidden');
        }
      });
    })
  }
  handleDefaultDropdowns()

  // Handle partner filters
  const handlePartnerFilters = () => {
    const partnerFilterContainer = document.querySelector('.partner-filters');

    if (!partnerFilterContainer) return

    const dropdowns = partnerFilterContainer.querySelectorAll('.dropdown');
    const selectedFilters = {
      status: '',
      category: '',
      region: ''
    };

    function applyFilters() {
      document.querySelectorAll('.single-partner').forEach(partner => {
        const matchesStatus = selectedFilters.status === '' || partner.dataset.status === selectedFilters.status;
        const matchesCategory = selectedFilters.category === '' || partner.dataset.category === selectedFilters.category;
        const matchesRegion = selectedFilters.region === '' || partner.dataset.region === selectedFilters.region;

        if (matchesStatus && matchesCategory && matchesRegion) {
            partner.classList.remove('hidden');
        } else {
            partner.classList.add('hidden');
        }
      });
    }

    dropdowns.forEach(dropdown => {
      const menuButton = dropdown.querySelector('.menu-button span');
      const dropdownType = dropdown.dataset.type;

      dropdown.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          dropdown.querySelectorAll('a').forEach(link => link.classList.remove('bg-gray-100'));
          event.currentTarget.classList.add('bg-gray-100');

          selectedFilters[dropdownType] = link.id === 'show-all' ? '' : link.id;
          menuButton.textContent = link.textContent;

          const dropdownMenu = dropdown.querySelector('.dropdown-menu');
          menuButton.setAttribute('aria-expanded', false);
          dropdownMenu.classList.add('hidden');

          applyFilters();
        });
      });
    });
  }
  handlePartnerFilters()
}